import React, { useEffect, useState } from 'react'
import ColumnsDevider from '../../../customControl/ColumnsDevider'
import Select from 'react-select';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { TravelAgentFinanceModel } from '../../../Models/TravelAgentModels';
import { alphaNumeric, alphaNumericspace, ApiNotRespondMessage, onlyNumeric } from '../../../components/commonClass/CommonValidation';
import { loaderActions } from '../../../_actions/loader.actions';
import { getAllData, postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../components/commonClass/Session';
import { travelAgentProps } from './TravelAgent.interface';

function TravelAgentFinance(props: travelAgentProps) {
  const { tabId, selectedTabId, setIsSaved, isConfirm, setIsConfirm, setIsRedirect, TravelAgentId, travelAgentOptionList, setWarningMessages, domainWiseDisable } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [formValue, setFormValue] = useState(new TravelAgentFinanceModel());

  const [disabled, setDisabled] = useState(location?.state?.disabled ?? true);
  const [editDisabled, setEditDisabled] = useState(location?.state?.editdisabled ?? true);
  const [clearDisabled, setClearDisabled] = useState(true);

  //#region API calling function
  const gettravelagentfinanceinfobyid = async (id: number) => {
    const travelAgentFinanceInfoById = await getAllData(`/midoffice/v1/GetTravelAgentFinanceInfoById?travelAgentId=${id}`)
    if (travelAgentFinanceInfoById?.status && travelAgentFinanceInfoById?.data) {
      setFormValue((form) => ({
        ...form,
        TravelAgentId: Number(id),
        BankMasterId: travelAgentFinanceInfoById?.data?.[0]?.BankMasterId,
        AccountNo: travelAgentFinanceInfoById?.data?.[0]?.AccountNo,
        IFSCCode: travelAgentFinanceInfoById?.data?.[0]?.IFSCCode,
        BranchName: travelAgentFinanceInfoById?.data?.[0]?.BranchName,
        CreditLimit: travelAgentFinanceInfoById?.data?.[0]?.CreditLimit,
        TravelAgentPaymentTermsMasterId: travelAgentFinanceInfoById?.data?.[0]?.TravelAgentPaymentTermsMasterId,
      }))
    }
  }
  //#endregion

  //#region call API when get token
  useEffect(() => {
    async function fetchData(AgentId: number) {
      dispatch(loaderActions.start())
      let statusoftoken = await verifytoken();
      if (statusoftoken) {
        const user: any = GetLocalStorage();
        setFormValue((form) => ({ ...form, TravelAgentId: AgentId, UserId: user?.userMasterID ?? 0 }))
        setIsSaved((save: any) => ({ ...save, Finance: true }));
        Promise.allSettled([
          gettravelagentfinanceinfobyid(AgentId)
        ])
        dispatch(loaderActions.end())
      }
      else {
        dispatch(loaderActions.end());
        ClearLocalStorage();
        dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
      }

    }
    const TAid = Number(location?.state?.Id > 0 ? location?.state?.Id : TravelAgentId);
    TAid > 0 && fetchData(TAid);
  }, [location, TravelAgentId])
  //#endregion

  //#region call Save/Update function when click on "Yes" on tab change
  useEffect(() => {
    if (isConfirm === 1 && selectedTabId === tabId) {
      handleSaveUpdate();
    }
  }, [isConfirm])
  //#endregion

  //#region onChange functions
  const handleSelectChange = (name: string, e: any) => {
    setIsSaved((save: any) => ({ ...save, Finance: false }));
    setEditDisabled(false);
    setClearDisabled(false);
    setFormValue((form) => ({ ...form, [name]: e?.value }))
  }

  const handleOnChange = (name: string, value: string) => {
    setIsSaved((save: any) => ({ ...save, Finance: false }));
    setEditDisabled(false);
    setClearDisabled(false);
    const result = name === "CreditLimit" ? Number(value) : value
    setFormValue((form) => ({ ...form, [name]: result }))
  }
  //#endregion

  //#region insert / update data function
  const handleSaveUpdate = async () => {
    dispatch(loaderActions.start());
    let statusoftoken = await verifytoken();
    if (statusoftoken) {
      setIsConfirm(isConfirm === 1 && selectedTabId === tabId ? 2 : 0);
      formValue.TravelAgentId = Number(formValue.TravelAgentId)
      const insertupdatetravelagenfinanceinfo = await postUsersData('/midoffice/v1/insertupdatetravelagenfinanceinfo', formValue);
      if (insertupdatetravelagenfinanceinfo?.status) {
        setIsSaved((save: any) => ({ ...save, Finance: true }));
        setIsRedirect(true);
        dispatch({ type: 'ALERTING', message: insertupdatetravelagenfinanceinfo?.message || ApiNotRespondMessage });
      }
      else {
        dispatch({ type: 'ALERTING', message: insertupdatetravelagenfinanceinfo?.message || ApiNotRespondMessage });
      }
      dispatch(loaderActions.end());
    }
    else {
      dispatch(loaderActions.end());
      ClearLocalStorage();
      dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
    }
  }
  //#endregion

  //#region clear function
  const handleClear = () => {
    setIsSaved((save: any) => ({ ...save, Finance: false }));
    setFormValue((form) => ({
      ...form,
      BankMasterId: 0,
      AccountNo: "",
      IFSCCode: "",
      BranchName: "",
      CreditLimit: 0,
      TravelAgentPaymentTermsMasterId: 0,
    }));
  }
  //#endregion

  //#region back function
  const handleBack = () => {
    navigate('/travel-agent-management');
  }
  //#endregion

  return (
    <div className='row mt-5'>
      <div className='mb-2'><h4 className='fw-bold'>Bank Account</h4></div>

      <ColumnsDevider label='Bank Name'>
        <Select
          className="dropdown select_dropdown custom_class"
          options={travelAgentOptionList?.bankMasterList}
          value={travelAgentOptionList?.bankMasterList?.filter((fil: any) => fil?.value === formValue.BankMasterId)}
          onChange={(e: any) => handleSelectChange('BankMasterId', e)}
          placeholder="Bank Name"
          isDisabled={disabled || domainWiseDisable?.isExternalUser}
          isSearchable
          isClearable
        />
      </ColumnsDevider>

      <ColumnsDevider label='Account Number'>
        <input type="text"
          id="AccountNo"
          className="form-control"
          name='AccountNo'
          value={formValue.AccountNo}
          onChange={(e: any) => {
            e.target.value?.length <= 16 &&
              handleOnChange(e.target.name, onlyNumeric(e.target.value))
          }}
          disabled={disabled || domainWiseDisable?.isExternalUser}
          maxLength={16}
          placeholder='Account Number'
        />
      </ColumnsDevider>

      <ColumnsDevider label='IFSC Code'>
        <input type="text"
          id="IFSCCode"
          className="form-control"
          name='IFSCCode'
          value={formValue.IFSCCode}
          onChange={(e: any) => {
            e.target.value?.length <= 11 &&
              handleOnChange(e.target.name, alphaNumeric(e.target.value))
          }}
          disabled={disabled || domainWiseDisable?.isExternalUser}
          placeholder='IFSC Code'
          maxLength={11}
        />
      </ColumnsDevider>

      <ColumnsDevider label='Branch Name'>
        <input type="text"
          id="BranchName"
          className="form-control"
          name='BranchName'
          value={formValue.BranchName}
          onChange={(e: any) => {
            e.target.value?.length <= 50 &&
              handleOnChange(e.target.name, alphaNumericspace(e.target.value))
          }}
          disabled={disabled || domainWiseDisable?.isExternalUser}
          placeholder='Branch Name'
          maxLength={50}
        />
      </ColumnsDevider>

      <ColumnsDevider label='Credit Limit'>
        <input type="text"
          id="CreditLimit"
          className="form-control"
          name='CreditLimit'
          value={formValue.CreditLimit > 0 ? formValue.CreditLimit : ""}
          onChange={(e: any) => {
            Number(e.target.value) <= 5000000 &&
              handleOnChange(e.target.name, onlyNumeric(e.target.value))
          }}
          disabled={disabled || domainWiseDisable?.isExternalUser}
          placeholder='Credit Limit'
        />
      </ColumnsDevider>

      <ColumnsDevider label='Payment Terms'>
        <Select
          className="dropdown select_dropdown custom_class"
          options={travelAgentOptionList?.paymentTerms}
          value={travelAgentOptionList?.paymentTerms?.filter((fil: any) => fil?.value === formValue.TravelAgentPaymentTermsMasterId)}
          onChange={(e: any) => handleSelectChange('TravelAgentPaymentTermsMasterId', e)}
          placeholder="Payment Terms"
          isDisabled={disabled || domainWiseDisable?.isExternalUser}
          isSearchable
          isClearable
        />
      </ColumnsDevider>

      <div className="mt-3 d-flex justify-content-center mt-5">
        <button type="button" className="btn btn-primary mx-1 px-3" id="btnAdd" onClick={handleSaveUpdate} disabled={editDisabled || disabled || domainWiseDisable?.isExternalUser} > {domainWiseDisable?.loginUserDomainMasterId !== 1 ? "Save AS Draft" : (location?.state?.type === "Edit" ? "Update" : "Save")} </button>
        <button type="button" className="btn btn-primary mx-1 px-3" id="btnClear" onClick={handleClear} disabled={clearDisabled || disabled || domainWiseDisable?.isExternalUser} >Clear</button>
        <button type="button" className="btn btn-primary mx-1 px-3" id="btnBack" onClick={handleBack}  >Back</button>
      </div>
    </div>
  )
}

export default TravelAgentFinance